<template>
	<div id="haoke1">
		<!-- 遮罩层 -->
		<header>
			<div class="title">
				<!-- <span class="hao">耗课列表</span> -->
			</div>
			<div class="countList">
				<ul>
					<li style="margin-right: 20px;">合计：<span class="money">{{ tableData.count}}</span>元</li>
<!--					<li style="margin-right: 20px;">耗课合计：<span class="part">{{ tableData.part}}</span>节</li>-->
					<li style="margin-right: 20px;">人数：<span class="person">{{ tableData.person}}</span>人</li>
				</ul>
				<!--<el-button size="mini" class="btn" style="margin: 0" v-on:click="changeActive" round>-->
					<!--{{ this.isactive ? '返回' : '未结课查询' }}-->
				<!--</el-button>-->
			</div>
		</header>
		<div class="tableheadBox">
			<div class="demo-input-suffix">
				<span>技师：</span>
				<el-select size="mini" class="msg" v-model="value1" clearable placeholder="请选择">
					<el-option v-for="item in teacher" :key="item.user_id" :label="item.username" :value="item.user_id"></el-option>
				</el-select>
			</div>

			<div class="demo-input-suffix" style="margin: 0 10px;">
				日期：
				<el-date-picker size="mini" class="shangsj" v-model="value2" type="daterange" start-placeholder="开始日期"
				 end-placeholder="结束日期" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>

<!--			<div class="demo-input-suffix">-->
<!--                课程/班级名称：-->
<!--				<el-input class="msg" size="mini" placeholder="" v-model="input1" @keyup.enter.native="searchk" clearable>-->
<!--				</el-input>-->
<!--			</div>-->
			<div class="demo-input-suffix" style="margin-left: 10px;">
				会员姓名：
				<el-input class="msg" size="mini" placeholder="" v-model="input2" @keyup.enter.native="searchk" clearable>
				</el-input>
			</div>
			<el-button v-on:click="searchk" size="mini" class="btns" icon="el-icon-search"></el-button>
      <a  :href="export_url" v-if="false" target="_blank" class="btn btn-success btn-xs" style="float: right;padding: 5px 14px;height: 30px;margin:0 20px 5px 20px">导出excel</a>
		</div>


		<div style="padding: 0 0.2rem">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th></th>
						<th>会员姓名</th>
						<th>计费项目</th>
						<th>技师</th>
						<th>次数</th>
						<th>单价</th>
						<th>金额合计</th>
						<th>日期</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,index) in tableData.data" :key="index">
						<td>{{index+1}}</td>
						<td>{{ta.baobao_name}}</td>
						<td>{{ta.kc_name}}</td>
						<td>{{ta.username}}</td>
						<td>{{ta.xiaohao}}</td>
						<td>{{ta.k_d}}</td>
						<td>{{ta.k_h}}</td>
						<td>{{ta.create_time}}</td>
					</tr>
					<tr v-if="tableData.data==''">
						<td colspan="10" align="center">暂无数据</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="block_page">
			共有{{tableData.total}}条记录 当前{{tableData.page}}页/共{{tableData.totalpage}}页
		</div>
		<div class="table-bottom">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tableData.page"
			 :page-size="pagesize" layout="prev, pager, next, jumper" :total='tableData.total'>
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				isactive: false,
				// count:'',
				// part:'',
				// person:'',
				tableData: {
					data: [],
					total: 0,
					page: 1,
					count: '',
					part: '',
					person: '',
					totalpage: '',
				},
				pagesize: 20,
				teacher: [],
				token: "",
				options: [{
					value: '选项1',
					label: '000'
				}, {
					value: '选项2',
					label: '666'
				}, {
					value: '选项3',
					label: '003'
				}],
				value1: '',
				value2: [],
				input1: '',
				input2: '',
				stime: '',
				etime: '',
				items:[],//项目
				item_id:'',
                centre_id:'',
                export_url:"javascript:void(0);"
			};
		},
        watch:{
            value1(){this.check_export_url();},
            value2(){this.check_export_url();},
            kc_name(){this.check_export_url();},
            input1(){this.check_export_url();},
            input2(){this.check_export_url();},
            item_id(){this.check_export_url();}
        },
		methods: {
            //重新生成导出链接参数
            check_export_url(){
                let that = this
                if (that.value2 != null) {
                    that.stime = that.value2[0]
                    that.etime = that.value2[1]
                } else {
                    that.stime = ''
                    that.etime = ''
                }
                that.export_url = process.env.apiUrl + "saas/export/export_hk?centre_id=" + that.centre_id + '&user_id='+that.value1
                    + '&time_s='+that.stime+'&time_e='+that.etime+'&kc_name='+that.input1+'&name='+that.input2+'&item_id='+that.item_id
            },
			hkdata: function() {
				let self = this;
				if (this.value2 != null) {
					self.stime = self.value2[0]
					self.etime = self.value2[1]
				} else {
					self.stime = ''
					self.etime = ''
				}

				$.ajax({
					url: process.env.apiUrl + "saas/biao/indexk",
					type: "post",
					data: {
						token: self.token,
						user_id: self.value1,
						time_s: self.stime,
						time_e: self.etime,
						kc_name: self.input1,
						name: self.input2,
						page: self.tableData.page,
						item_id: self.item_id
					},
					success: function(data) {
						if (data.status == 1) {
							self.tableData.data = data.data.data;
							self.tableData.total = data.data.count;
							self.tableData.person = data.data.count;
							self.tableData.count = data.data.he_money;
							self.tableData.part = data.data.hk_num;
							self.tableData.totalpage = data.data.total;
						} else if (data.status == 2) {
							self.tableData.data = ""
						}
					},
				})
			},
			wjkdata() {
				let self = this;
				if (this.value2 != null) {
					self.stime = self.value2[0]
					self.etime = self.value2[1]
				} else {
					self.stime = ''
					self.etime = ''
				}
				$.ajax({
					url: process.env.apiUrl + "saas/biao/wjk",
					type: "post",
					data: {
						token: self.token,
						user_id: self.value1,
						time_s: self.stime,
						time_e: self.etime,
						kc_name: self.input1,
						name: self.input2,
						page: self.tableData.page,
						item_id: self.item_id
					},
					success: function(data) {
						if (data.status == 1) {
							self.tableData.data = data.data.data;
							self.tableData.total = data.data.count;
							self.tableData.person = data.data.count;
							self.tableData.count = data.data.he_money;
							self.tableData.part = data.data.hk_num;

							self.tableData.totalpage = data.data.total;
						} else if (data.status == 2) {
							self.tableData.data = ''
						}

					},
				})
			},
			changeActive() {
				this.isactive = !this.isactive;
				this.value1 = '',
				this.value2 = '',
				this.input1 = '',
				this.input2 = '',
				this.searchk();
			},
			// 搜索
			searchk() {
				this.tableData.page = 1;
				if (this.isactive) {
					this.wjkdata();
				} else {
					this.hkdata();
				}
			},
			teacherdata() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + "saas/user/allstaff",
					type: "post",
					data: {
						token: self.token,
						type: 2
					},
					success: function(data) {
						self.teacher = data.data;
					},
				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.tableData.page = val;
				// this.tableData.page += 2;
				if (this.isactive == false) {
					this.hkdata();
				} else {
					this.wjkdata();
				}
			},
			//选择项目
			get_item(){
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/biao/item_type",
					data: {
						token: self.token,
					},
					success: function(res) {
						if (res.status == 1) {
							self.items = res.data
                            self.centre_id = res.centre_id
                            self.export_url = process.env.apiUrl + "saas/export/export_hk?centre_id=" + self.centre_id + '&user_id='+self.value1
                                + '&time_s='+self.stime+'&time_e='+self.etime+'&kc_name='+self.input1+'&name='+self.input2+'&item_id='+self.item_id
						}
					},
					error: function(data) {
						self.$message.error(`请求失败`);
					}
				});
			},
            jump: function(d) {
                this.$router.push(d)
            },
		},
		mounted: function() {
			this.token = $.cookie('token')

			this.hkdata()
			this.teacherdata()
			this.get_item()
		}

	}
</script>

<style scoped lang="less">
	#haoke1 {
		margin: 0;
		padding: 0;
		font-size: 14px;

		.block_page {
			padding: 0 5px;
		}

		.tableheadBox {
			display: flex;
			margin-bottom: 10px;
			/*justify-content: space-between;*/
			align-items: center;
			float: right;
			padding: 5px;
		}

		header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px 5px 0;

			.countList {
				margin: 10px 0;
				display: flex;
				justify-content: center;
				align-items: center;

				ul {
					margin: 0;
					list-style: none;
					display: flex;

					li {
						margin-right: 0.1rem;

						.money {
							color: #ff0204;
							padding: 0 5px;
						}

						.part {
							color: #46c1ac;
							padding: 0 5px;
						}

						.person {
							color: #00a6fc;
							padding: 0 5px;
						}

					}
				}
			}


		}

		.btn,
		.btn:hover {
			background-color: #E6BE8A !important;
			color: white !important;
			border: 0;
			padding: 3px 15px;
			font-size: 12px;
		}

		.btns{
			margin-right: 5px;
		}
		.btns,
		.btns:hover {
			background-color: #E6BE8A !important;
			color: white !important;
			border: 0;
		}

		.msg {
			width: 120px;
		}

		.shangsj {
			width: 200px;
		}

	}
</style>




// WEBPACK FOOTER //
// src/pages/haoke/haoke1.vue